<template>
<div class="white--text">
    <div v-for="(item, i) in $store.state.main.referenceList.menuItems" :key="i">
        <h3 >{{item}}</h3>
        <h4 v-for="(subitem, idx) in $store.state.main.referenceList.menuSubItems[item]" :key="idx">
            <router-link :to="'/adminpanel/'+ subitem.route">{{subitem.name}}</router-link>
        </h4>   
    </div>
</div>
</template>

<script>
import {
    mapActions
} from 'vuex'

export default {
    data: () => ({}),
    components: {},
    methods: {
        ...mapActions(['getReferenceList','getUserInfo'])        
    },
    mounted() {
        const refresh = 1
        this.getUserInfo(refresh)
        .then( d => this.getReferenceList() )
        .catch( err => console.log(err))
    }
}
</script>
